<div class="mt-5">
  <label></label>
</div>
<div class="card mt-2">
  <h5 class="card-header title"><i class="fas fa-file-contract"></i> {{ "TITLE.DOCUMENT-VERIFICATION" | translate }}
  </h5>
  <div class="card-body custom-background custom-height">
    <form class="mb-2" [formGroup]="verifybycodeForm">
      <div class="form-row">
        <div class="col-md-3 mb-3">
          <label class="font-weight-bold" for="verificationCodeInput">{{ "LABEL.VERIFICATION-CODE" | translate }}
            :</label>
          <input type="text"
                 class="form-control"
                 id="verificationCodeInput"
                 formControlName="resumeHash"
                 placeholder="{{ 'MESSAGE.ENTER-CODE' | translate }}"
                 [(ngModel)]="resumeHashResource"
                 (keyup)="cleanForm()"
                 (keyup.enter)="verify()"
                 [class.is-invalid]="isInvalidControl('resumeHash')">
          <div class="invalid-feedback">
            {{getErrorMessageBy('resumeHash') | translate}}
          </div>
        </div>
        <div class="col-md-2 mb-3 custom-mt-24">
          <button type="button" class="btn btn-outline-success custom-button" (click)="verify()">
            <i class="fa fa-search"></i> {{ "BUTTON.VERIFY" | translate }}
          </button>
        </div>
      </div>
    </form>
    <div *ngIf="!wrongVerification && !loading && isCanceled" class="alert alert-danger font-weight-bold" role="alert">
      <i
        class="fa fa-exclamation-circle custom-icon-danger"></i> {{ "MESSAGE.THE-DOCUMENT-HAS-BEEN-CANCELED" | translate }}
    </div>
    <div *ngIf="!wrongVerification && !loading && isModified && !isReplacerFinished"
         class="alert alert-danger font-weight-bold"
         role="alert">
      <i class="fa fa-exclamation-circle custom-icon-danger"></i>
      {{ "MESSAGE.DOCUMENT-HAS-BEEN-MODIFIED-AND-THAT-WILL-REPLACE-IS-BEING-PROCESSED" | translate }}
    </div>
    <div *ngIf="!wrongVerification && !loading && isModified && isReplacerFinished">
      <div id="listPanel">
        <ul class="list-group list-group-flush">
          <li class="list-group-item font-weight-bold">{{ "TITLE.MODIFICATION-HISTORY" | translate }}</li>
          <li class="list-group-item" *ngFor="let documentmodification of documentmodifications; let index=index">
            {{ "LABEL.DOCUMENT-DATED" | translate }}
            <b><i>{{documentmodification.documentByDocumentIdOld.createAt | dateformat}}</i></b>
            {{ "LABEL.WAS-MODIFIED-BY-THAT-OF-THE-DATE" | translate }}
            <b><i>{{documentmodification.documentByDocumentIdNew.createAt | dateformat}}</i></b> por
            {{ "LABEL.THE-MOTIVE" | translate }} <b><i>{{documentmodification.description}}</i></b>
          </li>
        </ul>
      </div>
      <div *ngIf="!wrongVerification && !loading && isModified && isReplacerFinished"
           class="alert alert-info mt-2 font-weight-bold"
           role="alert">
        <i class="fa fa-exclamation-circle custom-icon-danger"></i>
        {{ "MESSAGE.YOU-CAN-LOCATE-THE-VALID-DOCUMENT" | translate }}
        <a [href]="urlLastDocumentResource" target="_blank" rel="noopener">{{ "LINK.HERE" | translate }}!</a>
      </div>
    </div>
    <div class="mb-2 content-position-end" *ngIf="showTableOperatorsInfo && !isCanceled && !isModified">
      <button type="button" class="btn btn-outline-dark custom-button" (click)="verifyIntervalTimeDownload(resumeHashResource)"
              *ngIf="havePermissionToDownload">
        <i class="fa fa-download"></i> {{ "BUTTON.DOWNLOAD" | translate }}
      </button>
    </div>
    <div *ngIf="showTableOperatorsInfo && !isCanceled && !isModified" style="height: 90%">
      <div class="table-responsive mb-1 scroll-table1">
        <table class="table table-sm">
          <thead class="thead-dark">
          <tr>
            <th scope="col">#</th>
            <th scope="col"></th>
            <th scope="col">{{ "TABLE.HEADER.OPERATION" | translate }}</th>
            <th scope="col">{{ "TABLE.HEADER.BY" | translate }}</th>
            <th scope="col">{{ "TABLE.HEADER.CERTIFYING-ENTITY" | translate }}</th>
            <th scope="col">TSA</th>
            <th scope="col">{{ "TABLE.HEADER.DATE-TIME" | translate }}</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let operatorInfo of operatorsInfo; let index=index">
            <th scope="row">{{index + 1}}</th>
            <td class="custom-th">
              <i class="fa {{getClassOperatorInfo(operatorInfo)}}" (click)="showModalSignatureInfo(operatorInfo)"></i>
            </td>
            <td>{{operatorInfo.operationDescription | translate}}</td>
            <td>{{operatorInfo.operatorName}}</td>
            <td>{{operatorInfo.issuerCertName}}</td>
            <td>{{operatorInfo.tsa}}</td>
            <td>{{operatorInfo.certainDateTime}}</td>
            <td>
              <span class="badge badge-info" [hidden]="hasntCertificate(operatorInfo)"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Ver más"
                    (click)="openModalSeeCertificateDetail(index)">
              Ver más
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="{{getClassMaxHeight(operatorsInfo)}} auto-height">
        <ng2-pdfjs-viewer [pdfSrc]="urlStream"
                          [download]="false"
                          [print]="false"
                          [openFile]="false"
                          [showSpinner]="true"
                          scroll="V"
                          [viewBookmark]="false"
                          viewerId="documentVisor">
        </ng2-pdfjs-viewer>
      </div>
    </div>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>


